<div class="help-container">
  <div class="container">
    <h1>Leave Me Your Concern</h1>
    <div class="help-flex">
      <div class="flex-item">
        <h2>Help Desk</h2>
        <div class="help-desk">
          <form [formGroup]="helpDesk" (ngSubmit)="onHelpDeskSubmit()">
            <div class="row">
              <mat-form-field class="help-full-width">
                <mat-label>Full Name</mat-label>
                <input matInput formControlName="fullName" placeholder="Full Name" required>
              </mat-form-field>
            </div>
            <div class="row">
              <mat-form-field class="help-full-width col-xl-6">
                <mat-label>Email</mat-label>
                <input type="email" formControlName="clientMail" [errorStateMatcher]="matcher" matInput placeholder="naresh@nplus.io" required>
                <mat-error *ngIf="helpDesk.hasError('clientMail') && !helpDesk.hasError('required')">
                  Please enter a valid email address
                </mat-error>
                <mat-error *ngIf="helpDesk.hasError('required')">
                  Email is <strong>required</strong>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="row">
              <mat-form-field class="help-full-width">
                <mat-label>Leave me your concern</mat-label>
                <textarea matInput formControlName="concern" placeholder="Ex. I need to bring out my business online..."></textarea>
              </mat-form-field>
            </div>
            <button class="help-full-width" color="help-color" mat-raised-button type="submit">Leave it to me!</button>
          </form>
        </div>
  </div>
</div>
